import * as React from 'react';
import BookrunnersEntry from './BookrunnersEntry';
import { Button, Icon, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@symphony-ui/uitoolkit-components';
import useOption from 'components/customHooks';
import DownloadContext from 'contexts/DownloadContext';
import ApiServerRequest from 'models/ApiServerRequest';
import TrancheWrapper from '../../../../models/TrancheWrapper';
import { sendFetchError } from 'utils/messageUtils';
import Bookrunner from '../../../../models/meta/Bookrunner';
import BookrunnerEditModal from './editors/bookrunners/BookrunnerEditModal';
const BookrunnersModal = ({ bookrunners, callback, onClose, trancheIndex, transactionId }) => {
    const { apiFetchJson } = React.useContext(DownloadContext);
    const [bookrunnerIndex, setBookrunnerIndex] = React.useState();
    const [disabledAdd, setDisabledAdd] = React.useState(false);
    const [loadingRefresh, setLoadingRefresh] = React.useState(false);
    const tableContainer = React.useMemo(() => window.document.getElementById("new-issue-table") ?? window.document.body, []);
    const roleOptions = useOption('/syndicate/parties/role/options');
    const onClickAdd = React.useCallback(() => {
        setBookrunnerIndex(bookrunners.length);
    }, [bookrunners.length]);
    const onClickRefresh = React.useCallback(() => {
        const formData = new FormData();
        formData.append('transactionId', transactionId);
        formData.append('trancheIndex', trancheIndex.toString());
        const request = new ApiServerRequest('/syndicate/meta/bookrunners/recalc', { body: formData, method: 'PATCH' });
        (async () => {
            try {
                setLoadingRefresh(true);
                setDisabledAdd(true);
                const body = await apiFetchJson(request);
                const tranches = body.map(t => new TrancheWrapper(t));
                callback(tranches);
            }
            catch (error) {
                sendFetchError("Unable to refresh bookrunners", error, request);
            }
            finally {
                setLoadingRefresh(false);
                setDisabledAdd(false);
            }
        })();
    }, [apiFetchJson, callback, trancheIndex, transactionId]);
    return (React.createElement(React.Fragment, null,
        bookrunnerIndex !== undefined ?
            React.createElement(BookrunnerEditModal, { bookrunnerIndex: bookrunnerIndex, callback: callback, initialBookrunner: bookrunners[bookrunnerIndex] ?? new Bookrunner({}), onClose: () => setBookrunnerIndex(undefined), parentNode: tableContainer, roleOptions: roleOptions, trancheIndex: trancheIndex, transactionId: transactionId })
            : undefined,
        React.createElement(Modal, { parentNode: tableContainer, closeButton: true, onClose: onClose, show: true, size: "full-width" },
            React.createElement(ModalHeader, null,
                React.createElement(ModalTitle, null, "Manage Bookrunners")),
            React.createElement(ModalBody, null,
                React.createElement("div", { style: { display: 'grid', gridTemplateColumns: 'repeat(1, calc(30% - 1rem) calc(40% - 1.5rem) calc(30% - 1rem) 2rem 1.5rem)', gridAutoRows: 'minmax(2rem, max-content)' } }, bookrunners.map((b, bi) => (React.createElement(BookrunnersEntry, { bookrunner: b, key: (b.name ?? "none") + bi.toString(), roleOptions: roleOptions, setInitialBookrunner: () => setBookrunnerIndex(bi), transactionId: transactionId }))))),
            React.createElement(ModalFooter, null,
                React.createElement("div", { style: { marginRight: '0.5rem' } },
                    React.createElement(Button, { disabled: disabledAdd, onClick: onClickAdd, iconButton: true, size: 'small' },
                        React.createElement(Icon, { iconName: 'plus' }))),
                React.createElement(Button, { loading: loadingRefresh, onClick: onClickRefresh, iconButton: true, size: 'small' },
                    React.createElement(Icon, { iconName: 'reload' }))))));
};
export default BookrunnersModal;
